var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333008 8.72659L7.39301 1.66659H2.99967V0.333252H9.66634V6.99992H8.33301V2.60659L1.27301 9.66659L0.333008 8.72659Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.90bce38a59dabf380332be1bb6e03270.svg";
export { ForwardRef as ReactComponent };